import React,{useEffect} from 'react';
import './App.css';
import RouterManager from './components/RouterManager';
import { ResourcesProvider } from './components/ContextProvider';
import { UIComponentAndProvider } from './components/common';
import {API} from './services/api';

function App() {
  useEffect(() => { 
    /**
     * Registrar visita
     * Se hace el llamado servicio /visits/register-visit
     */
    API.postRegisterVisit();
}, []);

  return (
    <div className="App">
      <ResourcesProvider>
        <UIComponentAndProvider>

          <RouterManager />
        </UIComponentAndProvider>
      </ResourcesProvider>
      {/* <Header />  */}
    </div>
  );
}

export default App;
